import React, { useState } from 'react';
import PropTypes from 'prop-types';

import Box, { BoxProps as MuiBoxProps } from '@mui/material/Box';

import Helmet from '../../components/Helmet';
import Header from '../../components/Header';
import {
  ArrowLeftIcon,
  HomeIcon,
  Navigation,
} from '@classity-edtech/ui-base/dist/components/Displays';
import { Typography } from '@mui/material';
import { globalColours } from '@classity-edtech/ui-base/dist/style/source';
import { Link } from 'react-router-dom';
import { webPaths } from '../../routes/paths';

export interface WebLayoutProps extends MuiBoxProps {
  children: React.ReactNode;
}

const WebLayout = ({ children }: WebLayoutProps) => {
  const [openSidebar, setOpenSidebar] = useState(false);

  const toggleOpenSidebar = () => {
    setOpenSidebar(!openSidebar);
  };

  return (
    <>
      <Helmet />

      <Header toggleOpenSidebar={toggleOpenSidebar} isExpanded />

      <Box
        sx={{
          display: { xs: 'block', md: 'flex' },
          gap: 4,
          px: { xs: 2, md: 4 },
          height: 'calc(100dvh - 82px)',
        }}
      >
        <Box
          sx={{
            alignSelf: 'flex-end',
            position: 'sticky',
            top: '82px',
            display: 'flex',
            backgroundColor: globalColours['$global-colour-background-elevated'],
            zIndex: 100,
          }}
        >
          <Navigation
            openSidebar={openSidebar}
            closeSidebar={toggleOpenSidebar}
            sx={{
              width: { xs: '100%', md: '145px' },
              backgroundColor: globalColours['$global-colour-background-elevated'],
              zIndex: 100,
            }}
            activeNav={''}
            height={'calc(100dvh - 202px)'}
            sections={[
              {
                title: { name: '' },
                items: [
                  {
                    name: 'Home',
                    icon: 'HomeIcon',
                    onClick: () => {},
                  },
                  {
                    name: 'Dashboard',
                    icon: 'DashboardIcon',
                    onClick: () => {},
                  },
                  {
                    name: 'Mentions',
                    icon: 'ChatIcon',
                    onClick: () => {},
                  },
                  {
                    name: 'Follows',
                    icon: 'LikeIcon',
                    onClick: () => {},
                  },
                  {
                    name: 'Notes',
                    icon: 'Documents',
                    onClick: () => {},
                  },
                  {
                    name: 'Refer a friend',
                    icon: 'ReferralIcon',
                    onClick: () => {},
                  },
                ],
              },
              {
                title: { name: 'Learn' },
                items: [
                  {
                    name: 'Group Classes',
                    icon: 'UsersIcon',
                    onClick: () => {},
                  },
                  {
                    name: 'Private tuition',
                    icon: 'User',
                    onClick: () => {},
                  },
                  {
                    name: 'Performance',
                    icon: 'PerformanceIcon',
                    onClick: () => {},
                  },
                  {
                    name: 'Billing',
                    icon: 'RevenueIcon',
                    onClick: () => {},
                  },
                ],
              },
            ]}
            footer={[
              {
                name: 'Nigeria',
                icon: 'GlobalIcon',
                onClick: () => {},
              },
            ]}
            search={{
              value: '',
              onChange: e => {},
              placeHolder: 'Search Classity...',
            }}
          />
        </Box>

        <Box sx={{ width: '100%' }}>
          <Box
            sx={{
              display: { xs: 'none', md: 'flex' },
              gap: 1.5,
              alignItems: 'center',
              height: '48px',
              px: { xs: 0, md: 4 },
            }}
          >
            <Link to={webPaths.root} style={{ textDecoration: 'none' }}>
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 0.5,
                  color: globalColours['$global-colour-content-primary'],
                  '&:hover': {
                    color: globalColours['$global-colour-interactive-control-hover'],
                  },
                }}
              >
                <HomeIcon sx={{ width: 14, height: 14 }} />
                <Typography variant='body3'>Home</Typography>
              </Box>
            </Link>

            <ArrowLeftIcon sx={{ width: 14, height: 14, transform: 'rotate(180deg)' }} />

            <Typography variant='body3'>Nigerian Curriculum</Typography>

            <ArrowLeftIcon sx={{ width: 14, height: 14, transform: 'rotate(180deg)' }} />

            <Typography variant='body3'>Maths</Typography>
          </Box>

          <Box
            sx={{
              mt: { xs: 2, md: 9 },
            }}
          >
            {children}
          </Box>
        </Box>
      </Box>
    </>
  );
};

WebLayout.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
};

WebLayout.defaultProps = {
  children: null,
  className: null,
};

export default WebLayout;
